module.exports = __webpack_public_path__ + "static/media/cat-lg-2.269c71f6.jpg";